import { Box, Typography } from "@mui/material";

function TeamIndex(props: any) {

  return (
    <Box sx={{margin: 20 }} display="flex" flexDirection="column" alignContent="stretch">
      <Typography variant="h5" mb={10}>Team</Typography>
    </Box>
  );
}

export default TeamIndex;